import React from "react"

import { PostPreview } from "../types/Post"
import { getPostLink } from "../utils/links"
import SecondaryButton, { SecondaryButtonProps } from "./SecondaryButton"
import { getNavigateOnClickHandler } from "../utils/buttons"
import { useGlobalLanguageText } from "../utils/language"

interface Props extends Partial<Omit<SecondaryButtonProps, "classes">> {
  slug: PostPreview["slug"]
  classes?: Partial<SecondaryButtonProps["classes"]>
}

const ReadMoreButton = ({ slug, ...props }: Props) => {
  const { readButtonText } = useGlobalLanguageText()

  const href: string = getPostLink(slug)

  const handleClick = getNavigateOnClickHandler(href)

  return (
    <SecondaryButton href={href} onClick={handleClick} {...props}>
      {readButtonText}
    </SecondaryButton>
  )
}

export default ReadMoreButton
